var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 18C6 11.3726 11.3726 6 18 6H32C33.1046 6 34 5.10457 34 4C34 2.89543 33.1046 2 32 2H18C9.16344 2 2 9.16344 2 18V24C2 25.1046 2.89543 26 4 26C5.10457 26 6 25.1046 6 24V18Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 34C6 32.8954 5.10457 32 4 32C2.89543 32 2 32.8954 2 34V46C2 54.8366 9.16344 62 18 62H46C54.8366 62 62 54.8366 62 46V32C62 30.8954 61.1046 30 60 30C58.8954 30 58 30.8954 58 32V44.5415C53.4168 37.3751 42.888 37.4644 38.3167 44.3689L33.1483 38.2609C27.0207 31.0191 15.6167 31.8397 10.5889 39.8841L6.05352 47.1408C6.01811 46.7653 6 46.3848 6 46V34ZM55.1216 47.5772L56.8462 51.1407C55.4001 54.1865 52.7087 56.5265 49.4299 57.5027L41.0687 47.6213C43.814 41.7822 52.2428 41.6289 55.1216 47.5772ZM7.66693 52.1052C9.75633 55.6339 13.6019 58 18 58H44.6109L30.0948 40.8446C25.7179 35.672 17.5722 36.2581 13.9809 42.0041L7.69599 52.06C7.68647 52.0752 7.67678 52.0903 7.66693 52.1052Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5134 15.3379C57.2523 16.1589 58.5169 16.2255 59.3379 15.4866C60.1589 14.7477 60.2255 13.4831 59.4866 12.6621L53.4598 5.96559C51.0763 3.3173 46.9237 3.3173 44.5402 5.96558L38.5134 12.6621C37.7745 13.4831 37.841 14.7477 38.6621 15.4866C39.4831 16.2255 40.7477 16.1589 41.4866 15.3379L47 9.21189V26C47 27.1046 47.8954 28 49 28C50.1046 28 51 27.1046 51 26V9.21191L56.5134 15.3379Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.95aa865718b8243ecbecf3bbfe51edd9.svg";
export { ForwardRef as ReactComponent };